<template lang="pug">
div(class="events-popup")

    div(class="popup-title")
        span() Events from your Watchlist
        //v-icon(class="cursor-pointer" style="margin-top:-10px; float:right;" @click="close()") mdi-close

    div(class="popup-content")
        v-row(v-if="getNews.length > 0" class="mb-4")
            h4() News
            table()
                template(v-for="item of getNews")
                    tr
                        td(class="pr-3")
                            div(style="width:60px; height:19px")
                                Ticker(:stockId="item.stock_id")
                        td(class="pr-3 text-no-wrap") {{displayWhen(item.date, item.time)}}
                        td(class="width:100%") {{item.title}}

        v-row(v-if="getReports.length > 0" class="mb-4")
            h4() Reports
            table()
                template(v-for="item of getReports")
                    tr
                        td(class="pr-3")
                            Ticker(:stockId="item.stock_id")
                        td(class="pr-3 text-no-wrap") {{item.period}}
                        td(class="pr-3")
                            v-icon(class="red--text cursor-hover mt-1") $pdfFile
                        template(v-if="item.time_group==='PAST'")
                            td {{item.eps+', '+item.sales }}
                            td(style="padding-top:4px;")
                                v-sparkline(
                                    class="sparkline-color"
                                    style="width:200px; margin-right:0; margin-left:100px;"
                                    color="#4466BB"
                                    :value="item.eps_history"
                                    type="bar"
                                    line-width="14"
                                    padding=0
                                    width=200 height="50px")
                        template(v-else)
                            td(style="width:100%") {{  item.date_report }}


        v-row(v-if="getAlerts.length > 0" class="mb-4")
            h4() Trade Plan Alerts
            table
                template(v-for="item of getAlerts")
                    tr
                        td(class="pr-3")
                            Ticker(:stockId="item.stock_id")
                        td(class="pr-3") {{ item.reason }}
                        td(class="pr-3")
                            v-icon(class="bell-color") $bellAlarm
                        td(style="width:100%") {{ item.price_today }}
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from 'moment';
import Ticker from './Ticker.vue';

export default {
    name: "DialogNotifications",
    components: {
        Ticker
    },
    props: {
        value: Boolean
    },
    async mounted() {
        console.log('AAA'+this.user_id);
        console.log( this.getEvents );
        console.log('AAA-1');
    },
    computed: {
        ...mapGetters([
            'getEvents',
        ]),
        getNews() {
            return this.$store.getters.getEvents.news[0].news;
        },
        getReports() {
            return this.$store.getters.getEvents.reports;
        },
        getAlerts() {
            return this.$store.getters.getEvents.alerts;
        },
        getStaleResearch() {
            return this.$store.getters.getEvents.staleResearch;
        },
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        }
    },
    methods: {
        ...mapActions([
            'checkEvents',
        ]),
        displayWhen(date, time) {
            const today = new Date().toLocaleDateString('sv-SE', { weekday: 'long' });
            const dateDay = new Date(date).toLocaleDateString('sv-SE', { weekday: 'long' });

            if (dateDay === today) {
                return time.substring(0,5);
            }
            return dateDay;
        },
        close() {
            this.$emit('update:activated', false); // not working
            //this.$emit("close");
        },
        setColorOnReport(num) {
            if(num === 0) {
                return 'red1--text';
            } else if(num === 1) {
                return 'orange1--text';
            } else {
                return 'grey9--text';
            }
        },
        daysDiffFromTodaysDate(date) {
            const today = new Date().toISOString().substring(0, 10);

            const start = moment(today, 'YYYY-MM-DD');
            const end = moment(date, 'YYYY-MM-DD');

            const daysDiff = moment.duration(end.diff(start)).asDays();

            return daysDiff;
        },
    }
}
</script>

<style scoped>

.events-popup {
    padding: 22px;
    position: relative;
    z-index:10000;
    background: white;
    border: 1px solid rgba(0, 0, 0, .1);
    box-shadow: 0 0 12px rgba(0,0,0,.3);
    border-radius:8px;
}

.popup-content {
    height: 300px;
    max-height: 500px;
    overflow-y:scroll;
}

.events-popup .row {
    margin: 0;
}

.events-popup h4 {
    font-size: 13px;
    font-weight: 500;
    display: block;
    margin-bottom: 6px;
}

.events-popup table {
    width: 100%;
}

.events-popup table td {
    padding-bottom: 6px;
    vertical-align: top;
}

.events-popup table tr td:not(:first-child) {
    font-size: 13px;
    line-height: 1.2;
}

.sparkline-color >>> g {
    fill: #294d6d;
}
.bell-color >>> path {
    fill: #a8243c;
}
</style>
